import get from 'lodash.get';

const getErrorMessage = (rootState) => get(rootState, 'ui.errors.errorMessage', null);

export default getErrorMessage;
